import axios from "axios";

export const state = {
    reportwithdrawsperusers: [],
};

export const getters = {
    reportwithdrawsperusers: state => state.reportwithdrawsperusers,
};

export const mutations = {
    setReportWithdrawsPerUser(reportwithdrawsperusers, newValue) { state.reportwithdrawsperusers = newValue},
};

export const actions = {
    async fetchReportWithdrawsPerUser({ commit }) {
        await axios.get('/reportwithdrawperusers').then(res => {
            commit('setReportWithdrawsPerUser', res.data.withdraws)
        })
    },
    filterReportWithdrawsPerUser({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportwithdrawperusers";
        axios.post(url, formData).then((response) => {
            commit('setReportWithdrawsPerUser', response.data.withdraws)
        })
    },
};
